<div [ngClass]="claseContenedor()">
   <div class="vScroll">
      <div class="row">
         <div class="col-lg-11"></div>
         <button (click)="cancelar();" type="button" class="btn col-lg-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
               viewBox="0 0 16 16">
               <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
            </svg>
         </button>
      </div>
      <form autocomplete="off" [formGroup]=formulario (ngSubmit)="grabar()">
         <div class="row mb-3">
             <div class="col-lg-8">
                 <h2  [ngClass]="claseH2()">Mantenimiento de Vehículos</h2>
             </div>
         </div>
         <!-- <div class="form-group row mt-2"> -->
            <!-- <div class="col-lg-1 col-md-2"></div> -->
            <h2  *ngIf="cliente.codigo" class="col-lg-6 col-md-6 col-form-label text-center"><strong>{{cliente.nombreFiscal}}</strong></h2>
            <h2  *ngIf="!cliente.codigo" class="col-lg-6 col-md-6 col-form-label text-center">&nbsp;</h2>
        <!-- </div> -->
         <div class="form-group row">
             <div class="col-lg-1 col-md-2"></div>
             <label class="col-lg-1 col-md-2 col-form-label text-end">Matrícula</label>
             <div class="col-lg-2 col-md-4">
                 <input mTab (focusout)="validarCodigo();" class="form-control" id=codigo type="text" formControlName="codigo">
                 <small *ngIf="campoNoValido('codigo')" class="form-text text-danger">Debe contener un mínimo de 2 caracteres</small>
                 <small *ngIf="matriculaExistente" class="form-text text-danger">La Matrícula ya existe. No se grabará.</small>
             </div>
             <div class="col-lg-1">
             </div>
             <label class="col-lg-2 col-md-4 col-form-label text-end">Bastidor</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=bastidor type="text"  formControlName="bastidor">
             </div>
         </div>
        
       
         <!-- <hr> -->
         <div class="form-group row mt-2">
             <label class="col-lg-2 col-md-4 col-form-label text-end">Marca</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=marca type="text"  formControlName="marca">
             </div>
             <label class="col-lg-2 col-md-4 col-form-label text-end">Color</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=color type="text"  formControlName="color">
             </div>
         </div>
 
         <div class="form-group row mt-2">
             <label class="col-lg-2 col-md-4 col-form-label text-end">Modelo</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=modelo type="text" formControlName="modelo">
             </div>
             <label class="col-lg-2 col-md-4 col-form-label text-end">Año Modelo</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=anoModelo type="number"  formControlName="anoModelo">
             </div>
         </div>
         <div class="form-group row mt-2">
             <label class="col-lg-2 col-md-4 col-form-label text-end">Kilómetros</label>
             <div class="col-lg-3 col-md-6">
                 <input mTab class="form-control" id=kms type="number" formControlName="kms">
             </div>
         </div>
         <hr>
 
         <!-- ----------------------------------------------------------------------- -->
         <!--                                CARRUSEL                                 -->
         <!-- ----------------------------------------------------------------------- -->
 
         <!-- <app-carrusel *ngIf="this.imagenesCarrusel.length > 0" [imagenes]="imagenesCarrusel"></app-carrusel> -->
 
         <!-- ----------------------------------------------------------------------- -->
         <!--                           FILA OBSERVACIONES                            -->
         <!-- ----------------------------------------------------------------------- -->
 
         <div class="form-group row mt-4">
             <!-- <label class="col-lg-2 col-md-4 col-form-label text-end">Observaciones</label> -->
             <div class="col-lg-1"></div>
             <div class="mb-3 col-lg-9">
                 <label for="exampleFormControlTextarea1" class="form-label">Observaciones</label>
                 <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
             </div>
         </div>
 
 
         <div class="form-group row mt-4">
             <div class="col-lg-1"></div>
 
             <div class="col-lg-2 col-md-4 form-check ml13px">
                 <input class="form-check-input" type="checkbox" value="" id="bloqueado" formControlName="bloqueado">
                 <label class="form-check-label" for="bloqueado">
                   Bloqueado
                 </label>
             </div>
             <label class="col-lg-3 col-md-4 col-form-label text-end">Motivo Bloqueo</label>
             <div class="col-lg-4 col-md-8 ml-13px">
                 <input mTab class="form-control" id=motivoBloqueo type="text" placeholder="" formControlName="motivoBloqueo">
             </div>
 
 
         </div>
 
         <div class="form-group row mt-4">
             <div class="col-lg-5 col-md-4 form-check mt-2">
 
             </div>
 
 
             <label class="col-lg-2 col-md-4 col-form-label text-end">Fecha Baja</label>
             <div class="col-lg-3 col-md-5">
                 <input mTab class="form-control" id=fechaBaja type="date" placeholder="" formControlName="fechaBaja">
             </div>
         </div>
 
         <hr>
         <div class="row">
             <app-botonera class="botonera" [botones]="['grabar']"></app-botonera>
         </div>
     </form>
        <app-mensaje [mensaje]=mensaje (botonesClick)="controlBotones($event)"></app-mensaje>
   </div>
</div>